import { useEffect, useMemo, useState } from 'react';

export const useForm = (initialForm = {}) => {

    const [formState, setFormState] = useState(initialForm);
    const [elementResetFlag, setElementResetFlag] = useState(false);

    // Formateador de números (1,234.56)
    const numberFormatter = new Intl.NumberFormat('en-US', {
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });

    // Para campos tipo dinero: muestra con comas y guarda limpio para backend
    const onInputChangeForNumber = ({ target }) => {
        const { name, value } = target;

        const cleanValue = value.replace(/,/g, '');
        const validNumber = /^-?\d*\.?\d*$/.test(cleanValue);
        if (!validNumber) return;

        if (cleanValue === '' || cleanValue === '.') {
            setFormState(prev => ({
                ...prev,
                [name]: value,
                [`clean_${name}`]: null,
            }));
            return;
        }

        let [integerPart, decimalPart] = cleanValue.split('.');
        if (decimalPart !== undefined) decimalPart = decimalPart.slice(0, 2);

        const formattedInteger = numberFormatter.format(parseFloat(integerPart || 0));
        const formattedValue =
            decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;

        setFormState(prev => ({
            ...prev,
            [name]: formattedValue,
            [`clean_${name}`]: parseFloat(cleanValue),
        }));
    };

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setFormState({
            ...formState,
            [name]: value
        });
    }

    const formatNumber = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    };

    const onInputChangeThousands = ({ target }) => {
        const { name, value } = target;
        const newValue = formatNumber(value)
        setFormState({
            ...formState,
            [name]: value,
            [`${name}_formateado`]: newValue
        });
    }

    const onSelectSearchChange = (event) => {
        const { name, value } = event.target
        setFormState({
            ...formState,
            [name]: value
        });
    }

    const onCheckboxChange = (event) => {
        const { name, checked } = event.target
        setFormState({
            ...formState,
            [name]: checked
        });
    }

    const onResetForm = () => {
        setFormState(initialForm);
        setElementResetFlag((prev) => !prev);
    }

    return {
        ...formState,
        formState,
        elementResetFlag,
        setFormState,
        onInputChange,
        onInputChangeForNumber,
        onInputChangeThousands,
        onSelectSearchChange,
        onCheckboxChange,
        onResetForm,
    }
}